import React from 'react'

export const Logo = () => {
  return (
    <img src={'https://res.cloudinary.com/dpuasqaeb/image/upload/v1687374042/Work-Services/WhatsApp_Image_2023-06-21_at_1.59.49_PM_csbcmr.jpg'} alt="" className='imgPerson'/>
  )
}
